import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { getExpandedGridRows } from '../../../../../store/selectors/getExpandedGridRows';
import { collapseNavigationPanelRow, expandNavigationPanelRows } from '../../../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { RowActionButton } from './common/RowActionButton';
import { RowButtonProps } from './common/RowButtonProps';

interface Props extends RowButtonProps {
  visible: boolean;
}

export function ExpandCollapseButton({ visible, row }: Props) {
  const dispatch = useAppDispatch();
  const isExpanded = useAppSelector((state) => getExpandedGridRows(state).includes(row.rowId));

  return (
    <RowActionButton
      name="expand-collapse"
      icon={isExpanded ? ExpandMoreIcon : ChevronRightIcon}
      sx={[{ marginRight: 1, marginY: 0.25 }, !visible && { cursor: 'default', opacity: 0 }]}
      title={`${isExpanded ? 'Collapse' : 'Expand'} this row`}
      disableTooltip
      onClick={() => {
        if (isExpanded) {
          dispatch(collapseNavigationPanelRow(row.rowId));
        } else {
          dispatch(expandNavigationPanelRows([row.rowId]));
        }
      }}
    />
  );
}
